// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"93d36286","455":"da1f2676","977":"86b025b2"}[chunkId] + ".chunk.js";
};